export default {
  displayName: 'Attention Bar',
  allowableParents: ['Section'],
};
